import { useQuery } from "@tanstack/react-query";
import { cdFetch } from "../api";
import { queryKeys } from "../queryKeys";

const normalize = (input?: Array<string> | null) => {
  if (!Array.isArray(input) || input.length === 0) return null;
  return input.slice().sort();
};

export const useReportTrendFilters = (
  userEmail: string | null,
  navItem: string
) => {
  const { data, isLoading }: any = useQuery({
    queryKey: [queryKeys.reportTrends, userEmail],
    queryFn: () => getReportTrends(userEmail),
    enabled:
      navItem !== "summary" &&
      userEmail &&
      userEmail !== "" &&
      userEmail !== null &&
      userEmail !== undefined
        ? true
        : false,
    staleTime: 20000,
  });
  const reportFilterTrendData = { ...data?.data?.data };
  return { reportFilterTrendData, isLoading };
};

export function getReportTrends(userEmail: string | null) {
  const res = cdFetch(
    `/getAllFiltersReportTrends?email=${JSON.stringify(userEmail)}`
  );
  return res;
}

export const useReportTrendData = (
  commodity: string,
  type: string,
  district: Array<string>,
  isJPExcluded: number = 1
) => {
  const { data, isLoading }: any = useQuery({
    queryKey: [queryKeys.reportTrends, commodity, type, normalize(district), isJPExcluded],
    queryFn: () => getReportTrendData(commodity, type, district, isJPExcluded),
    enabled: !!commodity,
    staleTime: 20000,
  });
  const reportTrendData = { ...data?.data?.data };
  return { reportTrendData, isLoading };
};

export function getReportTrendData(
  commodity: string,
  type: string,
  district: Array<string>,
  isJPExcluded: number = 1
) {
  let qParams = "";
  if (district && district.length > 0) {
    qParams += `district=${JSON.stringify(
      district?.map((item) => encodeURIComponent(item))
    )}&`;
  }
  if (commodity && commodity.length > 0) {
    qParams += `commodity=${JSON.stringify(commodity)}&`;
  }

  if (type && type.length > 0) {
    qParams += `type=${JSON.stringify(type)}&`;
  }
  if (qParams.length > 0) {
    qParams = "?" + qParams.slice(0, -1);
  }
  const res = cdFetch(`/getReportTrendsData${qParams}${qParams ? "&" : "?"}isJPExcluded=${isJPExcluded}`);
  return res;
}

export function getReportTrendDataForExcel(
  commodity: string,
  type: string,
  district: Array<string>,
  isJPExcluded: number = 1

) {
  let qParams = "";
  if (district && district.length > 0) {
    qParams += `district=${JSON.stringify(
      district?.map((item) => encodeURIComponent(item))
    )}&`;
  }
  if (commodity && commodity.length > 0) {
    qParams += `commodity=${JSON.stringify(commodity)}&`;
  }

  if (type && type.length > 0) {
    qParams += `type=${JSON.stringify(type)}&`;
  }
  if (qParams.length > 0) {
    qParams = "?" + qParams.slice(0, -1);
  }
  const res = cdFetch(`/getExcelDownloadForTrends${qParams}${qParams ? "&" : "?"}isJPExcluded=${isJPExcluded}`);
  return res;
}

export function downloadJPExclusions(commodity: string) {
  let qParams = "";
  if (commodity && commodity.length > 0) {
    qParams = `?commodity=${encodeURIComponent(commodity)}`;
  }
  return cdFetch(`/downloadJPExclusions${qParams}`);
}
